import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ITenantLinkFieldsFragment = {
  id?: any | null
  tenantCalendarEndpoint?: string | null
  projectFromId?: any | null
  projectId: any
}

export type IGetTenantLinksQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetTenantLinksQuery = {
  tenantLinks?: {
    data: Array<{
      id?: any | null
      tenantCalendarEndpoint?: string | null
      projectFromId?: any | null
      projectId: any
    }>
  } | null
}

export type ISubscribeToTenantLinkMutationVariables = Types.Exact<{
  tenantLink: Types.Scalars['String']['input']
  projectId: Types.Scalars['ObjectId']['input']
}>

export type ISubscribeToTenantLinkMutation = {
  subscribeToTenantLink?: {
    id?: any | null
    tenantCalendarEndpoint?: string | null
    projectFromId?: any | null
    projectId: any
  } | null
}

export type IUnsubscribeFromTenantLinkMutationVariables = Types.Exact<{
  tenantLinkId: Types.Scalars['ObjectId']['input']
}>

export type IUnsubscribeFromTenantLinkMutation = {
  unsubscribeFromTenantLink?: {
    id?: any | null
    tenantCalendarEndpoint?: string | null
    projectFromId?: any | null
    projectId: any
  } | null
}

export const TenantLinkFieldsFragmentDoc = gql`
  fragment TenantLinkFields on TenantLink {
    id
    tenantCalendarEndpoint
    projectFromId
    projectId
  }
`
export const GetTenantLinksDocument = gql`
  query GetTenantLinks($projectId: ObjectId!) {
    tenantLinks(projectId: $projectId) {
      data {
        ...TenantLinkFields
      }
    }
  }
  ${TenantLinkFieldsFragmentDoc}
`

/**
 * __useGetTenantLinksQuery__
 *
 * To run a query within a React component, call `useGetTenantLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantLinksQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetTenantLinksQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetTenantLinksQuery,
    IGetTenantLinksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetTenantLinksQuery, IGetTenantLinksQueryVariables>(
    GetTenantLinksDocument,
    options,
  )
}
export function useGetTenantLinksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetTenantLinksQuery,
    IGetTenantLinksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetTenantLinksQuery,
    IGetTenantLinksQueryVariables
  >(GetTenantLinksDocument, options)
}
export type GetTenantLinksQueryHookResult = ReturnType<
  typeof useGetTenantLinksQuery
>
export type GetTenantLinksLazyQueryHookResult = ReturnType<
  typeof useGetTenantLinksLazyQuery
>
export type GetTenantLinksQueryResult = Apollo.QueryResult<
  IGetTenantLinksQuery,
  IGetTenantLinksQueryVariables
>
export const SubscribeToTenantLinkDocument = gql`
  mutation SubscribeToTenantLink($tenantLink: String!, $projectId: ObjectId!) {
    subscribeToTenantLink(tenantLink: $tenantLink, projectId: $projectId) {
      ...TenantLinkFields
    }
  }
  ${TenantLinkFieldsFragmentDoc}
`
export type ISubscribeToTenantLinkMutationFn = Apollo.MutationFunction<
  ISubscribeToTenantLinkMutation,
  ISubscribeToTenantLinkMutationVariables
>

/**
 * __useSubscribeToTenantLinkMutation__
 *
 * To run a mutation, you first call `useSubscribeToTenantLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTenantLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToTenantLinkMutation, { data, loading, error }] = useSubscribeToTenantLinkMutation({
 *   variables: {
 *      tenantLink: // value for 'tenantLink'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSubscribeToTenantLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISubscribeToTenantLinkMutation,
    ISubscribeToTenantLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISubscribeToTenantLinkMutation,
    ISubscribeToTenantLinkMutationVariables
  >(SubscribeToTenantLinkDocument, options)
}
export type SubscribeToTenantLinkMutationHookResult = ReturnType<
  typeof useSubscribeToTenantLinkMutation
>
export type SubscribeToTenantLinkMutationResult =
  Apollo.MutationResult<ISubscribeToTenantLinkMutation>
export type SubscribeToTenantLinkMutationOptions = Apollo.BaseMutationOptions<
  ISubscribeToTenantLinkMutation,
  ISubscribeToTenantLinkMutationVariables
>
export const UnsubscribeFromTenantLinkDocument = gql`
  mutation UnsubscribeFromTenantLink($tenantLinkId: ObjectId!) {
    unsubscribeFromTenantLink(tenantLinkId: $tenantLinkId) {
      ...TenantLinkFields
    }
  }
  ${TenantLinkFieldsFragmentDoc}
`
export type IUnsubscribeFromTenantLinkMutationFn = Apollo.MutationFunction<
  IUnsubscribeFromTenantLinkMutation,
  IUnsubscribeFromTenantLinkMutationVariables
>

/**
 * __useUnsubscribeFromTenantLinkMutation__
 *
 * To run a mutation, you first call `useUnsubscribeFromTenantLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromTenantLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromTenantLinkMutation, { data, loading, error }] = useUnsubscribeFromTenantLinkMutation({
 *   variables: {
 *      tenantLinkId: // value for 'tenantLinkId'
 *   },
 * });
 */
export function useUnsubscribeFromTenantLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUnsubscribeFromTenantLinkMutation,
    IUnsubscribeFromTenantLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUnsubscribeFromTenantLinkMutation,
    IUnsubscribeFromTenantLinkMutationVariables
  >(UnsubscribeFromTenantLinkDocument, options)
}
export type UnsubscribeFromTenantLinkMutationHookResult = ReturnType<
  typeof useUnsubscribeFromTenantLinkMutation
>
export type UnsubscribeFromTenantLinkMutationResult =
  Apollo.MutationResult<IUnsubscribeFromTenantLinkMutation>
export type UnsubscribeFromTenantLinkMutationOptions =
  Apollo.BaseMutationOptions<
    IUnsubscribeFromTenantLinkMutation,
    IUnsubscribeFromTenantLinkMutationVariables
  >
